import { sendSumoLog } from './sumoLogger';

export const fetchTicketLogs = async (fetchID, token, dispatch) => {
  // Log parameters
  console.log('[fetchTicketLogs] Parameters received', {
    fetchID,
  });

  const requestURL = encodeURI(
    `${process.env.REACT_APP_COUCHBASE_URL}/lmark/_changes?filter=sync_gateway/bychannel&channels=${fetchID}&include_docs=true`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });
    if (!data.ok) {
      const errorType = 'fetchTicketLogs';
      const message = `${data.status} - Fetching ticket logs for ${fetchID} failed`;
      const errorCode = data.status;
      console.log('[fetchTicketLogs] ERROR: Request failed', {
        fetchID,
        status: data.status,
        statusText: data.statusText,
      });
      sendSumoLog(errorType, message, errorCode, dispatch);
      return {};
    }
    const jsonData = await data.json();

    // Log the result
    console.log('[fetchTicketLogs] Result received', {
      fetchID,
      results: jsonData,
      lastSeq: jsonData.last_seq,
    });

    return jsonData;
  } catch (error) {
    const message = `fetch ticket logs ${fetchID} failed`;
    console.log('[fetchTicketLogs] ERROR: Exception caught', {
      fetchID,
      error: error.message || error,
      stack: error.stack,
    });
    sendSumoLog(error, message, dispatch);
    return {};
  }
};
